import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import './ModalCrearUsuario.css';

const OPCIONES_ESTADO_INGRESO = [
  { value: '1', label: 'Requerimiento' },
  { value: '2', label: 'En entrevista' },
  { value: '3', label: 'Entrevista final' },
  { value: '4', label: 'Terminado' },
];

function ModalPracticanteForm({ isOpen, onClose, onSave, row, areas }) {
  const [form, setForm] = useState({
    area_tipo_id: '',
    nombre_practicante: '',
    observaciones: '',
    estado: '1',
  });

  useEffect(() => {
    if (!isOpen) return;
    if (row) {
      setForm({
        area_tipo_id: row.area_tipo_id != null ? String(row.area_tipo_id) : '',
        nombre_practicante: row.nombre_practicante || '',
        observaciones: row.observaciones || '',
        estado: row.estado != null ? String(row.estado) : '1',
      });
    } else {
      setForm({
        area_tipo_id: '',
        nombre_practicante: '',
        observaciones: '',
        estado: '1',
      });
    }
  }, [isOpen, row]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.area_tipo_id) return alert('Seleccione el área.');
    if (!form.nombre_practicante.trim()) return alert('Ingrese el nombre del practicante.');
    const payload = {
      area_tipo_id: Number(form.area_tipo_id),
      nombre_practicante: form.nombre_practicante.trim(),
      observaciones: form.observaciones.trim() || null,
    };
    if (row) payload.id_requerimiento = row.id_requerimiento;
    try {
      await onSave(payload);
      onClose(true);
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || 'Error al guardar.');
    }
  };

  return (
    <Modal isOpen={isOpen} fade={false} className="custom-modal" backdrop="static" size="md">
      <ModalHeader className="modal-header">
        <div className="titulo">
          <h1>{row ? 'EDITAR REQUERIMIENTO' : 'NUEVO REQUERIMIENTO'}</h1>
          <Button className="close-btn" onClick={() => onClose(false)}>
            X
          </Button>
        </div>
      </ModalHeader>
      <div className="modal-body-footer">
        <ModalBody className="modal-body">
          <Form className="fila" onSubmit={(e) => e.preventDefault()}>
            <FormGroup>
              <Label>
                Área: <span style={{ color: 'red' }}>*</span>
              </Label>
              <Input
                type="select"
                name="area_tipo_id"
                className="form-control"
                value={form.area_tipo_id}
                onChange={handleChange}
              >
                <option value="">Seleccionar</option>
                {(areas || []).map((a) => (
                  <option key={`${a.tipo_id}`} value={String(a.tipo_id)}>
                    {a.descripcion || a.tipo_id}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label>
                Nombre del practicante: <span style={{ color: 'red' }}>*</span>
              </Label>
              <Input
                type="text"
                name="nombre_practicante"
                className="form-control"
                value={form.nombre_practicante}
                onChange={handleChange}
                maxLength={255}
              />
            </FormGroup>
            <FormGroup>
              <Label>Observaciones</Label>
              <Input
                type="textarea"
                name="observaciones"
                className="form-control"
                rows={3}
                value={form.observaciones}
                onChange={handleChange}
              />
            </FormGroup>
            {row && (
              <FormGroup>
                <Label>Estado</Label>
                <Input type="select" name="estado" className="form-control" value={form.estado} onChange={handleChange}>
                  {OPCIONES_ESTADO_INGRESO.map((o) => (
                    <option key={o.value} value={o.value}>
                      {o.label}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            )}
            <FormGroup>
              <div className="button-container">
                <Button className="button-custom" onClick={handleSubmit}>
                  {row ? 'ACTUALIZAR' : 'REGISTRAR'}
                </Button>
              </div>
            </FormGroup>
          </Form>
        </ModalBody>
      </div>
    </Modal>
  );
}

export default ModalPracticanteForm;
